import { useEffect } from 'react';

const WeddingRedirect = () => {
  useEffect(() => {
    window.location.href = 'https://abhashwedsmerina.netlify.app';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <p>Redirecting to wedding website...</p>
    </div>
  );
};

export default WeddingRedirect;
